module.exports = require('../../es/string/ends-with');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/features/string/ends-with.js
// module id = 235
// module chunks = 0